import { createRequest, throwResErrors } from "./requestUtil";
export const getIssues = () => {
	const url = `api/issues?sortOrder=asc&sortBy=priority&filters=${JSON.stringify({ issue_active: "ACTIVE" })}`;
	return createRequest()
		.get(url)
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};
